export default {
  desk: '',
  clientData: {
    primerNombre: '',
    segundoNombre: '',
    primerApellido: '',
    segundoApellido: '',
    identificacion: '',
    tipoIdentificacion: '',
    fechaNacimiento: '',
    edad: '',
    celular: '',
    email: '',
    actividadCliente: '',
    pagaduria: '',
    medioContacto: '',
    departamento: null,
    ciudad: null,
    genero: '',
    nivelEscolaridad: null,
    estrato: '',
    mensajeHabeasData: '',
    aceptacionHabeasData: true,
  },
  priceValueToSolicitate: {
    monto: '',
    tasa: '',
    plazo: '',
    diasInteresesIniciales: '',
    nivelEscolaridad: '',
  },
  financesData: {
    ingresos: '',
    descuentosLey: '',
    descuentosNomina: '',
    lineaCredito: '',
    destinoCredito: '',
    credits: {},
    fields: [{id: 0, value: ''}]
  },
  simulation: {}
}
